import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { toast } from "react-toastify";
import loginStateAtom from "../atoms/loginStateAtom";
import { url } from '../utils/config';
import uiConfigAtom from "../atoms/uiConfigAtom";
import login from "../assets/login.png";
import { btnOne, containerTwo, errorText, inputStyleTwo, subTitle } from "../utils/style";
import EmailScreen from "./EmailScreen";
import OtpScreen from "./OtpScreen";

function Login() {
    const [ uiConfig ] = useRecoilState(uiConfigAtom)
    const [ loggedIn, setLoggedIn ] = useRecoilState(loginStateAtom);
    const [ loginScreen, setLoginScreen ] = useState(true);
    const [ email, setEmail ] = useState('');
    const [ otp, setOtp ] = useState('');
    const [ uid, setUid ] = useState('');
    const [ error, setError ] = useState( );
    const navigate = useNavigate();

    const style = {
        backgroundColor: uiConfig?.primaryColor?.hex
    }


    async function getOtp() {
        if(email && email.match('@') && email.match('.')) {
            const reqUrl = url + '/get_otp/login';
            axios.post(reqUrl, {email})
            .then(res => {
                setUid(res.data.uid);
                // toast.success(res.data.message, { autoClose: 3000 })
                toast.success('Auth Code sent to email', { autoClose: 3000 })
                setTimeout(() => { 
                    setLoginScreen(false);
                } ,200)
            })
            .catch(err => {
                setError(null) 
                toast.error(err.response.data.message, { autoClose: 3000 });
                
            }) 
        } else {
            setError('')
            toast.error('Please enter a valid Email', { autoClose: 3000 })
        }
    }

    async function phoneLogin() {
        if(otp && otp.length === 6) {
            const reqUrl = url + '/login';  
            axios.post(reqUrl, { email, otp, uid})
            .then(res => {
                toast.success('Logged-In Successfully!', { autoClose: 3000 })
                window.localStorage.setItem('token', res.data.token);
                setError(null)
                setLoggedIn(true)
                navigate('/')
            })
            .catch(err => toast.error(err.response.data.message, { autoClose: 3000 }))
        } else {
            setError('')
            toast.error('Please enter a valid Auth Code', { autoClose: 3000 })
        }
    }                

    return(
        loginScreen ? 
        <EmailScreen email={email} setEmail={setEmail} error={error} getOtp={getOtp} uiConfig={uiConfig} /> 
        :
        <OtpScreen otp={otp} setOtp={setOtp} email={email} error={error} login={phoneLogin} getOtp={getOtp} setLoginScreen={setLoginScreen}/> 
    )
}

export default Login;